export default __webpack_public_path__ + "static/media/pos-project.aa3c4dac.jpg";